// extracted by mini-css-extract-plugin
export default {"discount":"discount_discount__NBONC","overlay":"discount_overlay__ChRHl","title":"discount_title__YNz0s","btn":"discount_btn__ny14y"};